export default function stringContainsOnlyChineseCharacters(string) {
  return !string || !!string.match(/^[ \u{4E00}-\u{9FFF}0-9,]*$/u);
}
